import React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "antd";
import CustomButton from "Components/CustomButton";
import { ReloadOutlined } from "@ant-design/icons";

const Declined = ({ customStyle, getMBWayReference, setSelectPaymentMethod }) => {
  const { t } = useTranslation();
  return (
    <div className="error">
      <Alert
        message={t("mbway.declinedTitle")}
        description={t("mbway.declinedDescription")}
        type="error"
        showIcon
      />
      <div style={{ textAlign: "center" }}>
        <CustomButton buttonStyle={customStyle} type="primary" onClick={() => getMBWayReference()}>
          {t("mbway.retryButton")} <ReloadOutlined />
        </CustomButton>
      </div>
      <div style={{ textAlign: "center" }}>
        <CustomButton buttonStyle={customStyle} type="link" onClick={() => setSelectPaymentMethod({ visible: true })}>
          {t("mbway.changeMethodButton")}
        </CustomButton>
      </div>
    </div>
  );
};

export default Declined;
